import { 
  DEFAULT_DASHBOARD_ID, 
  get_headers, 
  get_project_id, 
  GET_SUPERSET_GUEST_TOKEN, 
  SUPERSET_DOMAIN 
} from '@/utils/constants/constants';
import alert_mixin from '@/utils/mixins/alert_mixin';
import { embedDashboard } from '@superset-ui/embedded-sdk';
import axios from 'axios';

export default {
  name: 'DashboardEmbedding',
  mixins: [alert_mixin],

  data: () => ({
    token_available: true,
    superset_app: null,
    dashboard_id: '',
    superset_domain: '',
    project_id: null,
    is_loading: false
  }),

  async mounted() {
    await this.load_data();
  },

  beforeUnmount() {
    if (this.superset_app) {
      this.superset_app.unmount();
      this.superset_app = null;
    }
  },

  methods: {
    async load_data() {
      const loader = await this.show_loader("Loading Dashboard...");
      this.is_loading = true;

      try {
        // Assign values properly (no need for Promise.all here)
        this.project_id = get_project_id() || this.$route.params.project_id || null;
        this.superset_domain = SUPERSET_DOMAIN || '';
        this.dashboard_id = this.$route.params.dashboard_id || DEFAULT_DASHBOARD_ID || '';

        await this.embed_dashboard();
      } catch (error) {
        this.show_error('Error loading dashboard: ' + error);
      } finally {
        this.close_loader(loader);
        this.is_loading = false;
      }
    },

    get_guest_token() {
      return axios.post(
        GET_SUPERSET_GUEST_TOKEN,
        {
          dashboard_id: this.dashboard_id,
          project_id: this.project_id
        },
        { headers: get_headers() }
      )
      .then(response => {
        return response?.data?.token || null;
      })
      .catch(() => {
        this.show_error('Failed to fetch guest token');
        this.token_available = false;
        return null;
      });
    },

    async embed_dashboard() {
      if (this.superset_app) {
        this.superset_app.unmount();
        this.superset_app = null;
      }

      const token = await this.get_guest_token();
      if (!token) return;

      try {
        const dashboard = await embedDashboard({
          id: this.dashboard_id,
          supersetDomain: this.superset_domain,
          mountPoint: this.$refs.dashboardContainer,
          fetchGuestToken: () => token,
          dashboardUiConfig: {
            hideTitle: true,
            filters: { visible: false, expanded: false },
          },
        });

        this.superset_app = dashboard;
      } catch (err) {
        this.token_available = false;
      }
    }
  },

  watch: {
    '$route.params.dashboard_id': {
      immediate: false,
      async handler(newId, oldId) {
        if (newId && newId !== oldId) {
          this.dashboard_id = newId;
          await this.load_data();
        }
      }
    }
  }
};
